import { render, staticRenderFns } from "./Comunicados-Listagem.vue?vue&type=template&id=2feda018&"
import script from "./Comunicados-Listagem.vue?vue&type=script&lang=js&"
export * from "./Comunicados-Listagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Comunicados-Listagem.vue"
export default component.exports